import React, { useContext, useRef, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { CrudForm, useEntityManager, AuthContext } from 'elentari'
import tarefaEmbarcadorRepository from './tarefaEmbarcadorRepository'
import yupValidation from '../../../lib/yupValidation'
import arrayMutators from 'final-form-arrays'
import { Card, makeStyles, Step, StepButton, Stepper } from '@material-ui/core'
import ChatCard from '../../Chats/ChatCard'
import MiniStepper from '../../../components/MiniStepper'
import ComplexDialog from '../../../components/ComplexDialog'
import { TarefaStatusColors, TarefaStatusEnum } from '../TarefaStatus'
import { AnexosCard } from '../Anexos'
import * as R from 'ramda'
import { tarefaSchemaEmbarcador } from './tarefaSchema'
import { concatObservacao } from '../../../utils/ConcatObservacao'
import MonitoramentoEmbarcadorForm from '../Form/MonitoramentoEmbarcadorForm'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2)
  },
  mainStepper: {
    overflowX: 'scroll',
    marginBottom: theme.spacing(2)
  },
  reanalise: {
    fontSize: '0.695em',
    height: '100%',
    lineHeight: '105%',
    backgroundColor: TarefaStatusColors.REANALISE,
    '&:hover': {
      color: 'white',
      backgroundColor: TarefaStatusColors.REANALISE_DARK
    }
  }
}))

export const validateTarefa = yupValidation(tarefaSchemaEmbarcador)

const TarefaEmbarcadorForm = props => {
  const classes = useStyles()
  const { user } = useContext(AuthContext)
  const elementRef = useRef()
  const steps = getSteps()
  const [activeStep, setActiveStep] = useState(0)
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    callback: null,
    id: 0,
    mensagem: '',
    isPendente: false
  })

  const entityManager = useEntityManager({
    repository: tarefaEmbarcadorRepository
  })
  function getSteps() {
    return ['Informações gerais']
  }
  const isNew = !!entityManager.isNew

  if (!entityManager.isNew) {
    steps.push('Anexos')
    steps.push('Comentários')
  }

  const cannotUpdate =
    (R.isEmpty(entityManager.item) && !entityManager.isNew) ||
    (!R.isEmpty(entityManager.item) &&
      (!!entityManager.item.dataTermino ||
        entityManager.item?.status !== TarefaStatusEnum.PENDENTEFILIAL))

  const canCommentChat =
    (R.isEmpty(entityManager.item) && !entityManager.isNew) ||
    (!R.isEmpty(entityManager.item) && entityManager.item.dataTermino)

  const unmask = value => value.replace(/\W/g, '')

  const handleSubmit = async data => {
    const submitData = {
      data: {
        ...data,
        origem: 'Filial',
        cpfMotorista: unmask(data.cpfMotorista),
        nomeMotorista: data.nomeMotorista,
        placaCavalo: unmask(data.placaCavalo),
        observacao: concatObservacao(
          data.observacao,
          data.novaObservacao,
          user.name
        )
      },
      cnh: data.cnh,
      crlv: data.crlv,

      crlvPlaca1: data.crlvPlaca1,
      crlvPlaca2: data.crlv2,
      crlvPlaca3: data.crlv3,
      isca: data.isca ? data.isca : undefined
    }
    delete submitData.data.novaObservacao
    return entityManager.onSubmit(submitData)
  }

  const scrollTop = () => {
    const stepElement = document.getElementById('content')
    setTimeout(() => {
      stepElement && stepElement.scrollIntoView()
    }, 200)
  }

  const handleStep = (values, step) => async () => {
    setActiveStep(values, step)
    scrollTop()
  }

  const handleActionsClick = async (id, callback, operacao) => {
    setConfirmationDialog({
      open: true,
      callback,
      id,
      mensagem: `O novo status dessa Solicitação de Monitoramento será: ${operacao}`,
      isPendente: operacao === 'Pendente'
    })
  }

  const closeDialog = () => {
    setConfirmationDialog({
      mensagem: '',
      isPendente: false,
      open: false,
      callback: null,
      id: 0
    })
  }

  const handleConfirmationDialog = async data => {
    const { id, callback } = confirmationDialog
    if (callback) {
      await callback(id, data)
      entityManager.getItem()
    }
  }

  const customActionsFactory = item => {
    if (item.dataTermino) {
      if (user.realm === 'admin' || user.realm === 'analista_op_2') {
        return [
          {
            label: 'Habilitar edição',
            props: {
              color: 'secondary',
              className: classes.habilitarEdicao,
              variant: 'contained'
            },
            onClick: () =>
              handleActionsClick(
                item.id,
                tarefaEmbarcadorRepository.removerDataTermino,
                'Aberto e a Data de Término será removida.'
              )
          }
        ]
      }
      return []
    }

    const reanalise = {
      can: ['admin', 'analista_op', 'analista_op_2'],
      label: 'Reánalise',
      props: {
        color: 'inherit',
        className: classes.reanalise,
        variant: 'contained'
      },
      onClick: () => {
        handleActionsClick(
          item.id,
          tarefaEmbarcadorRepository.reanaliseEmbarcador,
          'Reanalise'
        )
      }
    }

    const actions = []
    switch (item.status) {
      case TarefaStatusEnum.PENDENTEFILIAL:
        actions.push(reanalise)
        break
      default:
        break
    }
    return actions
  }

  const customActions = customActionsFactory(entityManager.item)

  const renderContent = ({ values, form, showError, ...props }) => {
    return (
      <MonitoramentoEmbarcadorForm
        {...props}
        values={values}
        form={form}
        showError={showError}
        isNew={isNew}
      />
    )
  }

  return (
    <>
      <MiniStepper
        elementRef={elementRef}
        steps={steps}
        activeStep={activeStep}
        handleStep={(values, index) => handleStep(values, index)}
      />
      <Card className={classes.mainStepper}>
        <Stepper activeStep={activeStep} nonLinear>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepButton onClick={handleStep(index)}> {label} </StepButton>
            </Step>
          ))}
        </Stepper>
      </Card>

      {activeStep === 0 && (
        <CrudForm
          {...props}
          {...entityManager}
          onSubmit={handleSubmit}
          withPaper
          validate={validateTarefa}
          formProps={{ mutators: { ...arrayMutators } }}
          customActions={customActions}
          disableSubmit={cannotUpdate}
        >
          {renderContent}
        </CrudForm>
      )}
      {activeStep === 1 && (
        <Card className={classes.card}>
          <AnexosCard match={props.match} cannotUpdate={cannotUpdate} />
        </Card>
      )}
      {activeStep === 2 && (
        <Card className={classes.card}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <ChatCard tarefa {...props} cannotUpdate={canCommentChat} />
            </Grid>
          </Grid>
        </Card>
      )}
      <ComplexDialog
        open={!!confirmationDialog.open}
        buttonLabel="Não"
        handleClose={closeDialog}
        primaryAction={handleConfirmationDialog}
        title="Deseja confirmar essa operação?"
        message={confirmationDialog.mensagem}
        primaryActionButtonLabel="Confirmar"
      />
    </>
  )
}

export default TarefaEmbarcadorForm
